import { LocationDetailForm } from "@/features/location/detail/LocationDetailForm";
import { useModal } from "@/features/modal/ModalStackManager";
import { DetailLink } from "@/features/ui/detail/DetailLink";
import { setToLocaleString } from "@/utils/unitMark";
import { Table } from "@mantine/core";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

export const LotList = ({ lotsData, unitText }: any) => {
  const transformedData =
    lotsData?.length &&
    lotsData?.flatMap((item: any) =>
      item.inventories.map((inventory: any) => ({
        itemCode: item.itemCode,
        name: item.name,
        expiration: item.expiration,
        location: inventory?.locationCode || "-",
        quantity: inventory?.quantity || "-",
      })),
    );

  const { openModal } = useModal();
  const { t } = useTranslation();

  return (
    <Table style={{ borderCollapse: "separate", borderSpacing: 0 }}>
      <thead style={{ position: "sticky", top: 0, zIndex: 10 }}>
        <tr>
          <th rowSpan={2}>{t("item.code")}</th>
          <th rowSpan={2}>{t("lot.name")}</th>
          <th rowSpan={2}>{t("lot.lotExpiration")}</th>
          <th colSpan={2}>{t("inventory.inventory")}</th>
        </tr>
        <tr>
          <th>{t("location.location")}</th>
          <th>{t("inventory.quantity")}</th>
        </tr>
      </thead>
      <tbody>
        {lotsData?.length ? (
          <>
            {transformedData?.map((item: any) => (
              <tr key={item.itemCode + item.name + item.location}>
                <td>{item.itemCode}</td>
                <td>{item.name}</td>
                <td>{item.expiration ? dayjs(item.expiration).format("YYYY-MM-DD") : ""}</td>
                <td>
                  <DetailLink
                    onClick={() =>
                      openModal(<LocationDetailForm locationCode={item.location} />, null, "")
                    }
                    justify={"flex-start"}
                  >
                    {item.location}
                  </DetailLink>
                </td>
                <td>
                  {setToLocaleString(item.quantity)} {unitText}
                </td>
              </tr>
            ))}
          </>
        ) : (
          <tr>
            <td colSpan={5}>{t("lot.notFound")}</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};
